/**
 * @file Wev Event 网页事件数据
 */
import {
  percentTextFormatter,
  percentCellFormatter,
  integerValueFormatter,
  moneyFormatterWithUnit,
  durationFormatter,
} from 'src/const/statistics/formatters';
import { EVENT_ATTRIBUTE } from 'src/const/statistics/metrics-emun';

//  页面事件数据
export const EnumPageEventData = [
  {
    i18nPath: 'common_web_event_shopping_roas', // 事件名
    key: 'event_shopping_roas', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_shopping_roas',
    children: [
      {
        i18nPath: 'common_web_event_shopping_roas_count', // 次数
        key: 'time_attr_shopping_roas', // {metric}
        hint: 'campaign_hover_stat_data.shopping_roas',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: durationFormatter, // 格式化表格数据
      },
      {
        key: 'time_attr_cost_per_shopping_roas', // cost_per_{metric}
        disabled: true,
      },
      {
        key: 'time_attr_shopping_roas_per_click', // {metric}_per_click
        disabled: true,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_shopping', // 事件名
    key: 'event_shopping', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_shopping',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_shopping_count', // 次数
        key: 'time_attr_shopping', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_shopping',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_shopping', // 单次消耗
        key: 'time_attr_cost_per_shopping', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_shopping',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_shopping_per_click', // 频率
        key: 'time_attr_shopping_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_shopping_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_shopping', // 每个Event的平均价值
        key: 'time_attr_value_per_shopping', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_shopping',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_shopping_value', // 总付费价值 / 100000
        key: 'time_attr_total_shopping_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_shopping_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_view', // 事件名
    key: 'event_view', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_view',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_view_count', // 次数
        key: 'time_attr_view', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_view',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_view', // 单次消耗
        key: 'time_attr_cost_per_view', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_view',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_view_per_click', // 频率
        key: 'time_attr_view_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_view_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter, // 格式化表格头
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_view', // 每个Event的平均价值
        key: 'time_attr_value_per_view', // {metric}_per_click
        hint: 'campaign_hover_stat_data.value_per_view',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_view_value', // 总付费价值 / 100000
        key: 'time_attr_total_view_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_view_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_button', // 事件名
    key: 'event_button', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_button',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_button_count', // 次数
        key: 'time_attr_button', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_button',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_button', // 单次消耗
        key: 'time_attr_cost_per_button', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_button',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_button_per_click', // 频率
        key: 'time_attr_button_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_button_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_button', // 每个Event的平均价值
        key: 'time_attr_value_per_button', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_button',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_button_value', // 总付费价值 / 100000
        key: 'time_attr_total_button_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_button_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_consult', // 事件名
    key: 'event_consult', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_consult',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_consult_count', // 次数
        key: 'time_attr_consult', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_consult',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_consult', // 单次消耗
        key: 'time_attr_cost_per_consult', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_consult',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_consult_per_click', // 频率
        key: 'time_attr_consult_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_consult_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_consult', // 每个Event的平均价值
        key: 'time_attr_value_per_consult', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_consult',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_consult_value', // 总付费价值 / 100000
        key: 'time_attr_total_consult_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_consult_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_on_web_register', // 事件名
    key: 'event_on_web_register', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_on_web_register',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_on_web_register_count', // 次数
        key: 'time_attr_on_web_register', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_on_web_register',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_on_web_register', // 单次消耗
        key: 'time_attr_cost_per_on_web_register', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_on_web_register',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_on_web_register_per_click', // 频率
        key: 'time_attr_on_web_register_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_on_web_register_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_on_web_register', // 每个Event的平均价值
        key: 'time_attr_value_per_on_web_register', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_on_web_register',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_on_web_register_value', // 总付费价值 / 100000
        key: 'time_attr_total_on_web_register_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_on_web_register_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_on_web_detail', // 事件名
    key: 'event_on_web_detail', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_on_web_detail',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_on_web_detail_count', // 次数
        key: 'time_attr_on_web_detail', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_on_web_detail',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_on_web_detail', // 单次消耗
        key: 'time_attr_cost_per_on_web_detail', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_on_web_detail',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_on_web_detail_per_click', // 频率
        key: 'time_attr_on_web_detail_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_on_web_detail_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_on_web_detail', // 每个Event的平均价值
        key: 'time_attr_value_per_on_web_detail', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_on_web_detail',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_on_web_detail_value', // 总付费价值 / 100000
        key: 'time_attr_total_on_web_detail_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_on_web_detail_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_on_web_cart', // 事件名
    key: 'event_on_web_cart', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_on_web_cart',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_on_web_cart_count', // 次数
        key: 'time_attr_on_web_cart', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_on_web_cart',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_on_web_cart', // 单次消耗
        key: 'time_attr_cost_per_on_web_cart', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_on_web_cart',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_on_web_cart_per_click', // 频率
        key: 'time_attr_on_web_cart_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_on_web_cart_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_on_web_cart', // 每个Event的平均价值
        key: 'time_attr_value_per_on_web_cart', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_on_web_cart',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_web_cart_value', // 总付费价值 / 100000
        key: 'time_attr_total_on_web_cart_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_on_web_cart_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_on_web_order', // 事件名
    key: 'event_on_web_order', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_on_web_order',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_on_web_order_count', // 次数
        key: 'time_attr_on_web_order', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_on_web_order',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_on_web_order', // 单次消耗
        key: 'time_attr_cost_per_on_web_order', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_on_web_order',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_on_web_order_per_click', // 频率
        key: 'time_attr_on_web_order_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_on_web_order_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_on_web_order', // 每个Event的平均价值
        key: 'time_attr_value_per_on_web_order', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_on_web_order',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_button_on_web_order', // 总付费价值 / 100000
        key: 'time_attr_total_on_web_order_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_on_web_order_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  // Initiate Checkout
  {
    i18nPath: 'common_web_initiate_checkout', // 事件名
    key: 'event_initiate_checkout', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_initiate_checkout',
    hoverKey: 'campaign_hover_stat_data.event_initiate_checkout',
    children: [
      {
        i18nPath: 'module_initiate_checkout', // 次数
        key: 'time_attr_initiate_checkout_count', // {metric}
        hint: 'campaign_hover_stat_data.initiate_checkout',
        hoverKey: 'campaign_hover_stat_data.initiate_checkout',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'module_cost_per_initiate_checkout', // 单次消耗
        key: 'time_attr_cost_per_initiate_checkout_count', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_initiate_checkout',
        hoverKey: 'campaign_hover_stat_data.cost_per_initiate_checkout',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'module_initiate_checkout_per_click', // 开始下单率
        key: 'time_attr_initiate_checkout_count_per_click',
        hint: 'campaign_hover_stat_data.initiate_checkout_per_click',
        hoverKey: 'campaign_hover_stat_data.initiate_checkout_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'module_value_per_initiate_checkout', // 每个Event的平均价值
        key: 'time_attr_value_per_initiate_checkout_count',
        hint: 'campaign_hover_stat_data.value_per_initiate_checkout',
        hoverKey: 'campaign_hover_stat_data.value_per_initiate_checkout',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'module_total_initiate_checkout_value', // 总付费价值 / 100000
        key: 'time_attr_total_initiate_checkout_value',
        hint: 'campaign_hover_stat_data.total_initiate_checkout_value',
        hoverKey: 'campaign_hover_stat_data.total_initiate_checkout_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  // Add Billing
  {
    i18nPath: 'common_web_event_add_billing', // 事件名
    key: 'event_add_billing', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_add_billing',
    hoverKey: 'campaign_hover_stat_data.event_add_billing',
    children: [
      {
        i18nPath: 'module_add_billing', // 次数
        key: 'time_attr_add_billing_count', // {metric}
        hint: 'campaign_hover_stat_data.add_billing',
        hoverKey: 'campaign_hover_stat_data.add_billing',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'module_cost_per_add_billing', // 单次消耗 支付信息成本
        key: 'time_attr_cost_per_add_billing_count', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_add_billing',
        hoverKey: 'campaign_hover_stat_data.cost_per_add_billing',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'module_add_billing_per_click', // 支付信息率
        key: 'time_attr_add_billing_count_per_click',
        hint: 'campaign_hover_stat_data.add_billing_per_click',
        hoverKey: 'campaign_hover_stat_data.add_billing_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'module_value_per_add_billing', // 单次支付信息价值
        key: 'time_attr_value_per_add_billing_count',
        hint: 'campaign_hover_stat_data.value_per_add_billing',
        hoverKey: 'campaign_hover_stat_data.value_per_add_billing',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'module_total_add_billing_value', // 添加支付信息总价值
        key: 'time_attr_total_add_billing_value',
        hint: 'campaign_hover_stat_data.total_add_billing_value',
        hoverKey: 'campaign_hover_stat_data.total_add_billing_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  // Search
  {
    i18nPath: 'common_web_event_search', // 事件名
    key: 'event_search', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_search',
    hoverKey: 'campaign_hover_stat_data.event_search',
    children: [
      {
        i18nPath: 'module_search', // 次数
        key: 'time_attr_search_count', // {metric}
        hint: 'campaign_hover_stat_data.search',
        hoverKey: 'campaign_hover_stat_data.search',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'module_cost_per_search', // 单次搜索成本
        key: 'time_attr_cost_per_search_count', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_search',
        hoverKey: 'campaign_hover_stat_data.cost_per_search',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'module_search_per_click', // 搜索率
        key: 'time_attr_search_count_per_click',
        hint: 'campaign_hover_stat_data.search_per_click',
        hoverKey: 'campaign_hover_stat_data.search_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'module_value_per_search', // 单次搜索价值平均价值
        key: 'time_attr_value_per_search_count',
        hint: 'campaign_hover_stat_data.value_per_search',
        hoverKey: 'campaign_hover_stat_data.value_per_search',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'module_total_search_value', // event的总价值
        key: 'time_attr_total_search_value',
        hint: 'campaign_hover_stat_data.total_search_value',
        hoverKey: 'campaign_hover_stat_data.total_search_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_form_detail', // 事件名
    key: 'event_form_detail', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_form_detail',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_form_detail_count', // 次数
        key: 'time_attr_form_detail', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_form_detail',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_form_detail', // 单次消耗
        key: 'time_attr_cost_per_form_detail', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_form_detail',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_form_detail_per_click', // 频率
        key: 'time_attr_form_detail_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_form_detail_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_form_detail', // 每个Event的平均价值
        key: 'time_attr_value_per_form_detail', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_form_detail',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_form_detail_value', // 总付费价值 / 100000
        key: 'time_attr_total_form_detail_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_form_detail_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_form_button', // 事件名
    key: 'event_form_button', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_form_button',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_form_button_count', // 次数
        key: 'time_attr_form_button', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_form_button',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_form_button', // 单次消耗
        key: 'time_attr_cost_per_form_button', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_form_button',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_form_button_per_click', // 频率
        key: 'time_attr_form_button_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_form_button_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_form_button', // 每个Event的平均价值
        key: 'time_attr_value_per_form_button', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_form_button',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_form_button_value', // 总付费价值 / 100000
        key: 'time_attr_total_form_button_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_form_button_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_form', // 事件名
    key: 'event_form', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_form',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_form_count', // 次数
        key: 'time_attr_form', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_form',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_form', // 单次消耗
        key: 'time_attr_cost_per_form', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_form',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_form_per_click', // 频率
        key: 'time_attr_form_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_form_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_form', // 每个Event的平均价值
        key: 'time_attr_value_per_form', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_form',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_form_value', // 总付费价值 / 100000
        key: 'time_attr_total_form_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_form_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_phone_detail', // 事件名
    key: 'event_phone_detail', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_phone_detail',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_phone_detail_count', // 次数
        key: 'time_attr_phone_detail', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_phone_detail',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_phone_detail', // 单次消耗
        key: 'time_attr_cost_per_phone_detail', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_phone_detail',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_phone_detail_per_click', // 频率
        key: 'time_attr_phone_detail_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_phone_detail_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_phone_detail', // 每个Event的平均价值
        key: 'time_attr_value_per_phone_detail', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_phone_detail',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_phone_detail_value', // 总付费价值 / 100000
        key: 'time_attr_total_phone_detail_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_phone_detail_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_phone_button', // 事件名
    key: 'event_phone_button', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_phone_button',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_phone_button_count', // 次数
        key: 'time_attr_phone_button', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_phone_button',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_phone_button', // 单次消耗
        key: 'time_attr_cost_per_phone_button', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_phone_button',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_phone_button_per_click', // 频率
        key: 'time_attr_phone_button_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_phone_button_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_phone_button', // 每个Event的平均价值
        key: 'time_attr_value_per_phone_button', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_phone_button',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_phone_button_value', // 总付费价值 / 100000
        key: 'time_attr_total_phone_button_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_phone_button_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_phone', // 事件名
    key: 'event_phone', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_phone',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_phone_count', // 次数
        key: 'time_attr_phone', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_phone',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_phone', // 单次消耗
        key: 'time_attr_cost_per_phone', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_phone',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_phone_per_click', // 频率
        key: 'time_attr_phone_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_phone_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_phone', // 每个Event的平均价值
        key: 'time_attr_value_per_phone', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_phone',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_phone_value', // 总付费价值 / 100000
        key: 'time_attr_total_phone_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_phone_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_download_detail', // 事件名
    key: 'event_download_detail', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_download_detail',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_download_detail_count', // 次数
        key: 'time_attr_download_detail', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_download_detail',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_download_detail', // 单次消耗
        key: 'time_attr_cost_per_download_detail', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_download_detail',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_download_detail_per_click', // 频率
        key: 'time_attr_download_detail_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_download_detail_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_download_detail', // 每个Event的平均价值
        key: 'time_attr_value_per_download_detail', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_download_detail',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_download_detail_value', // 总付费价值 / 100000
        key: 'time_attr_total_download_detail_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_download_detail_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_download_button', // 事件名
    key: 'event_download_button', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_download_button',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_download_button_count', // 次数
        key: 'time_attr_download_button', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_download_button',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_download_button', // 单次消耗
        key: 'time_attr_cost_per_download_button', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_download_button',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_download_button_per_click', // 频率
        key: 'time_attr_download_button_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_download_button_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_download_button', // 每个Event的平均价值
        key: 'time_attr_value_per_download_button', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_download_button',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_download_button_value', // 总付费价值 / 100000
        key: 'time_attr_total_download_button_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_download_button_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_web_event_download_start', // 事件名
    key: 'event_download_start', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.event_download_start',
    children: [
      {
        i18nPath: 'common_web_event_time_attr_download_start_count', // 次数
        key: 'time_attr_download_start', // {metric}
        hint: 'campaign_hover_stat_data.time_attr_download_start',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_web_event_time_attr_cost_per_download_start', // 单次消耗
        key: 'time_attr_cost_per_download_start', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.time_attr_cost_per_download_start',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_web_event_time_attr_download_start_per_click', // 频率
        key: 'time_attr_download_start_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.time_attr_download_start_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_value_per_download_start', // 每个Event的平均价值
        key: 'time_attr_value_per_download_start', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_download_start',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_time_attr_total_download_start_value', // 总付费价值 / 100000
        key: 'time_attr_total_download_start_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_download_start_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_on_web_add_to_wishlist', // 事件父节点
    key: 'event_add_to_wishlist', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.on_web_add_to_wishlist_title',
    children: [
      {
        i18nPath: 'common_in_web_event_on_web_add_to_wishlist', // 次数
        key: 'time_attr_on_web_add_to_wishlist', // {metric}
        hint: 'campaign_hover_stat_data.on_web_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_web_event_cost_per_on_web_add_to_wishlist', // 单次消耗
        key: 'time_attr_cost_per_on_web_add_to_wishlist', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_on_web_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_on_web_add_to_wishlist_per_click', // 频率
        key: 'time_attr_on_web_add_to_wishlist_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.on_web_add_to_wishlist_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_value_per_on_web_add_to_wishlist', // 每个Event的平均价值
        key: 'time_attr_value_per_on_web_add_to_wishlist', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_on_web_add_to_wishlist',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_total_on_web_add_to_wishlist_value', // 总付费价值 / 100000
        key: 'time_attr_total_on_web_add_to_wishlist_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_on_web_add_to_wishlist_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
  {
    i18nPath: 'common_on_web_subscribe', // 事件父节点
    key: 'event_subscribe', // event_{event} 只是标识作用，不会传到后端
    hint: 'campaign_hover_stat_data.on_web_subscribe_title',
    children: [
      {
        i18nPath: 'common_in_web_event_on_web_subscribe', // 次数
        key: 'time_attr_on_web_subscribe', // {metric}
        hint: 'campaign_hover_stat_data.on_web_subscribe',
        attribute: EVENT_ATTRIBUTE.EVENT_COUNT.value,
        sortable: true,
        formatter: integerValueFormatter, // 格式化表格数据
      },
      {
        i18nPath: 'common_in_web_event_cost_per_on_web_subscribe', // 单次消耗
        key: 'time_attr_cost_per_on_web_subscribe', // cost_per_{metric}
        hint: 'campaign_hover_stat_data.cost_per_on_web_subscribe',
        attribute: EVENT_ATTRIBUTE.COST_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_on_web_subscribe_per_click', // 频率
        key: 'time_attr_on_web_subscribe_per_click', // {metric}_per_click
        hint: 'campaign_hover_stat_data.on_web_subscribe_per_click',
        attribute: EVENT_ATTRIBUTE.RATE_PER_EVENT.value,
        sortable: true,
        textFormatter: percentTextFormatter, // 格式化表格头
        formatter: percentCellFormatter,
      },
      {
        i18nPath: 'common_in_web_event_value_per_on_web_subscribe', // 每个Event的平均价值
        key: 'time_attr_value_per_on_web_subscribe', // total_{metric}_value
        hint: 'campaign_hover_stat_data.value_per_on_web_subscribe',
        attribute: EVENT_ATTRIBUTE.VALUE_PER_EVENT.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
      {
        i18nPath: 'common_in_web_event_total_on_web_subscribe_value', // 总付费价值 / 100000
        key: 'time_attr_total_on_web_subscribe_value', // value_per_{metric}
        hint: 'campaign_hover_stat_data.total_on_web_subscribe_value',
        attribute: EVENT_ATTRIBUTE.TOTAL_EVENT_VALUE.value,
        sortable: true,
        formatter: moneyFormatterWithUnit,
      },
    ],
  },
];
